import authorizedFetch from "../utilities/authorizedFetch";
import { BASE_URL } from "../config/constants";

const endpointURL = `${BASE_URL}/user`;

export const listPrograms = payload => {
  return authorizedFetch(`${endpointURL}/listPrograms`, {
    method: "POST",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json"
    }
  });
};

export const switchProgram = payload => {
  return authorizedFetch(`${endpointURL}/switchProgram`, {
    method: "POST",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json"
    }
  });
};

export const getFeed = payload => {
  return authorizedFetch(`${endpointURL}/feed`, {
    method: "POST",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json"
    }
  });
};

export const signup = payload => {
  return authorizedFetch(`${endpointURL}/signup`, {
    method: "POST",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json"
    }
  });
};

export const login = payload => {
  return authorizedFetch(`${endpointURL}/login`, {
    method: "POST",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json"
    }
  });
};

export const changePassword = payload => {
  return authorizedFetch(`${endpointURL}/changePassword`, {
    method: "POST",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json"
    }
  });
};



// WEBPACK FOOTER //
// ./src/api/user.js